import iso27001 from "./iso27001";
import nen7510 from "./nen7510";
import iso42001 from "./iso42001";

export const CUSTOM_CONTROL_NAME = "Custom control";

export const Options = (language, securityStandard) => {
  let standardObj;
    
  if(securityStandard === 'NEN7510') {
    standardObj = nen7510;
  }
  else if(securityStandard === 'ISO42001') {
    standardObj = iso42001;
  }
  else 
  {
    standardObj = iso27001;
  }

  return standardObj.map((option) => {
    const isCustomControl = option.Name === CUSTOM_CONTROL_NAME;
    return {
      value: option.ID,
      label: option.ID + " " + (language === 'nl' ? option.NameNL : option.Name),
      controlTxt: language === 'nl' ? option.ControlTxtNL : option.ControlTxt,
      isCustomControl,
    };
  });
};

